/*
 * return locale
 */
import { isClientSideRendering } from "/ssr-utils/ssr-env";

let ssrLocale = undefined;

export const setLocaleForSSR = (locale) => {
  ssrLocale = locale;
};

// Note: For vue components please prefer to get the locale from `this.$i18n.locale` and not via this helper.
export default (path) => {
  if (path === undefined) {
    if (isClientSideRendering()) {
      path = window.location.pathname;
    } else {
      return ssrLocale || "en";
    }
  }
  return path === "/de" || path.indexOf("/de/") === 0 ? "de" : "en";
};
